module.exports = __webpack_public_path__ + "img/air_close.7f477164.png";